const adminMenuItems = [
  {
    action: 'SUBMENU',
    color: '#EB3E8E',
    icon_name: 'menu',
    id: '1-admin',
    is_active: true,
    menu: 1,
    order: 1,
    authority: ['view_menuitem', 'view_submenuitem'],
    sub_menu_items: [
      {
        has_cap: true,
        icon_name: 'filter',
        id: 'menu-1',
        is_active: true,
        menu_item: 1,
        order: 1,
        title_en: 'Menu Item List',
        title_bn: 'মেনু আইটেম লিস্ট',
        url: `/admin/menu`,
        authority: ['view_menuitem'],
      },
      {
        has_cap: true,
        icon_name: 'filter',
        id: 'menu-2',
        is_active: true,
        menu_item: 2,
        order: 2,
        title_bn: 'সাব-মেনু লিস্ট',
        title_en: 'Sub-menu List',
        url: `/admin/sub-menu`,
        authority: ['view_submenuitem'],
      },
    ],
    title_bn: 'মেনু ম্যানেজমেন্ট',
    title_en: 'Menu Management',
    url: '',
  },
  {
    action: 'SUBMENU',
    color: '#7C8FB9',
    icon_name: 'images',
    id: '2-admin',
    is_active: true,
    menu: 2,
    order: 2,
    authority: [
      'view_banner',
      'view_secondarylogo',
      'view_dashboardslider',
      'add_footerimage',
      'change_footerimage',
    ],
    sub_menu_items: [
      {
        has_cap: true,
        icon_name: 'image_alt',
        id: 'image-1',
        is_active: true,
        menu_item: 1,
        order: 1,
        title_bn: 'ব্যানার',
        title_en: 'Banner',
        url: `/admin/banner`,
        authority: ['view_banner'],
      },
      {
        has_cap: true,
        icon_name: 'image_alt',
        id: 'image-2',
        is_active: true,
        menu_item: 2,
        order: 2,
        title_bn: 'সেকেন্ডারি লোগো',
        title_en: 'Secondary Logo',
        url: `/admin/secondary-logo`,
        authority: ['view_secondarylogo'],
      },
      {
        has_cap: true,
        icon_name: 'image_alt',
        id: 'image-3',
        is_active: true,
        menu_item: 3,
        order: 3,
        title_bn: 'কেরাওসেল',
        title_en: 'Carousel',
        url: `/admin/carousel`,
        authority: ['view_dashboardslider'],
      },
    ],
    title_en: 'Image Management',
    title_bn: 'ইমেজ ম্যানেজমেন্ট',
    url: '',
  },
  {
    action: 'SUBMENU',
    color: '#3DB7E4',
    icon_name: 'bulb',
    id: '3-admin',
    is_active: true,
    menu: 3,
    order: 3,
    authority: ['view_fact', 'add_factcard', 'change_factcard'],
    sub_menu_items: [
      {
        has_cap: true,
        icon_name: 'chat',
        id: '1-facts',
        is_active: true,
        menu_item: 1,
        order: 1,
        title_bn: 'ফ্যাক্টস',
        title_en: 'Facts',
        url: `/admin/facts`,
        authority: ['view_fact'],
      },
      {
        has_cap: true,
        icon_name: 'factCard',
        id: '2-facts',
        is_active: true,
        menu_item: 2,
        order: 2,
        title_bn: 'ফ্যাক্ট কার্ড',
        title_en: 'Fact Card',
        url: `/admin/fact-card`,
        authority: ['add_factcard', 'change_factcard'],
      },
    ],
    title_bn: 'ডিড ইউ নো',
    title_en: 'Did You Know',
  },
  {
    action: 'SUBMENU',
    color: '#80379B',
    icon_name: 'event',
    id: '4-admin',
    is_active: true,
    menu: 4,
    order: 4,
    authority: ['view_event'],
    sub_menu_items: [
      {
        has_cap: true,
        icon_name: 'calender',
        id: 'events-1',
        is_active: true,
        menu_item: 1,
        order: 1,
        title_bn: 'ইভেন্টস',
        title_en: 'Events',
        url: `/admin/events`,
        authority: ['view_event'],
      },
    ],
    title_bn: 'সেট ইভেন্টস',
    title_en: 'Set Events',
  },
  {
    action: 'SUBMENU',
    color: '#C9D600',
    icon_name: 'news',
    id: '5-admin',
    is_active: true,
    menu: 5,
    order: 5,
    authority: ['view_notice'],
    sub_menu_items: [
      {
        has_cap: true,
        icon_name: 'news',
        id: 'carousel-1',
        is_active: true,
        menu_item: 1,
        order: 1,
        title_bn: 'নিউস লিস্ট',
        title_en: 'News List',
        url: `/admin/news-carousel`,
        authority: ['view_notice'],
      },
    ],
    title_bn: 'নিউস ম্যানেজমেন্ট',
    title_en: 'News Management',
    url: '',
  },
  {
    action: 'SUBMENU',
    color: '#F6B547',
    icon_name: 'footer',
    id: '6-admin',
    is_active: true,
    menu: 6,
    order: 6,
    authority: [
      'add_contact',
      'change_contact',
      'delete_contact',
      'view_footerlink',
      'view_footerbottom',
    ],
    sub_menu_items: [
      {
        has_cap: true,
        icon_name: 'contacts',
        id: 'contacts-1',
        is_active: true,
        menu_item: 2,
        order: 1,
        title_bn: 'ইম্পরট্যান্ট কন্টাক্টস লিস্ট ',
        title_en: 'Important Contacts List',
        url: `/admin/important-contacts`,
        authority: ['add_contact', 'change_contact', 'delete_contact'],
      },
      {
        has_cap: true,
        icon_name: 'link',
        id: 'contacts-2',
        is_active: true,
        menu_item: 2,
        order: 1,
        title_bn: 'ফুটার লিংকস লিস্ট',
        title_en: 'Footer Links List',
        url: `/admin/footer-links`,
        authority: ['view_footerlink'],
      },
      {
        has_cap: true,
        icon_name: 'list',
        id: 'contacts-2',
        is_active: true,
        menu_item: 2,
        order: 1,
        title_bn: 'নিচের ফুটার লিস্ট',
        title_en: 'Footer Bottom List',
        url: `/admin/footer-bottom`,
        authority: ['view_footerbottom'],
      },
      {
        has_cap: true,
        icon_name: 'image_alt',
        id: 'image-4',
        is_active: true,
        menu_item: 2,
        order: 2,
        title_bn: 'ফুটার ইমেজ',
        title_en: 'Footer Image',
        url: `/admin/footer/upload`,
        authority: ['add_footerimage', 'change_footerimage'],
      },
    ],
    title_bn: 'ফুটার ম্যানেজমেন্ট',
    title_en: 'Footer Management',
    url: '',
  },
  {
    action: 'SUBMENU',
    color: '#4E5732',
    icon_name: 'visit',
    id: '8-admin',
    is_active: true,
    menu: 8,
    order: 8,
    authority: ['view_externalcard'],
    sub_menu_items: [
      {
        has_cap: true,
        icon_name: 'post',
        id: 'contacts-1',
        is_active: true,
        menu_item: 2,
        order: 1,
        title_bn: 'ভিসিট কার্ডস',
        title_en: 'Visit Cards',
        url: `/admin/visit-card`,
        authority: ['view_externalcard', 'view_taxrebate'],
      },
      {
        has_cap: true,
        icon_name: 'moneyCoin',
        id: 'audit',
        is_active: true,
        menu_item: 2,
        order: 2,
        title_bn: 'ট্যাক্স কার্ড',
        title_en: 'Tax Card',
        url: `/admin/tax-card`,
        authority: ['change_taxrebate', 'view_taxrebate'],
      },
    ],
    title_bn: 'ড্যাশবোর্ড কার্ডস',
    title_en: 'Dashboard Cards',
    url: '',
  },
  {
    action: 'SUBMENU',
    color: '#CFAA89',
    icon_name: 'shield',
    id: '7-admin',
    is_active: true,
    menu: 7,
    order: 7,
    authority: ['view_user', 'add_user', 'view_permissiongroup'],
    sub_menu_items: [
      {
        has_cap: true,
        icon_name: 'fingerprint',
        id: 'contacts-1',
        is_active: true,
        menu_item: 2,
        order: 1,
        title_bn: 'ইউসার পার্মিশন্স',
        title_en: 'User Permissions',
        url: `/admin/userPermission`,
        authority: ['view_user', 'add_user'],
      },
      {
        has_cap: true,
        icon_name: 'people',
        id: 'contacts-2',
        is_active: true,
        menu_item: 2,
        order: 1,
        title_bn: 'মেনেজ পারমিশন গ্রুপস',
        title_en: 'Manage Permission Groups',
        url: `/admin/userPermissionGroup`,
        authority: ['view_permissiongroup'],
      },
    ],
    title_bn: 'পার্মিশন্স',
    title_en: 'Permissions',
    url: '',
  },
  {
    action: 'SUBMENU',
    color: '#89cfba',
    icon_name: 'bell',
    id: '9-admin',
    is_active: true,
    menu: 9,
    order: 9,
    authority: [
      'add_notificationmaster',
      'view_headernotice',
      'view_notificationmaster',
    ],
    sub_menu_items: [
      {
        has_cap: true,
        icon_name: 'bell',
        id: 'notification-1',
        is_active: true,
        menu_item: 1,
        order: 1,
        title_bn: 'সেন্ড স্পেসিফিক ইউসার',
        title_en: 'Send Specific User',
        url: `/admin/notification`,
        authority: ['add_notificationmaster'],
      },
      {
        has_cap: true,
        icon_name: 'vibration',
        id: 'notification-2',
        is_active: true,
        menu_item: 2,
        order: 2,
        title_bn: 'সেন্ড অল ইউসার',
        title_en: 'Send All User',
        url: `/admin/notification-all`,
        authority: ['add_notificationmaster'],
      },
      {
        has_cap: true,
        icon_name: 'vibration',
        id: 'notification-3',
        is_active: true,
        menu_item: 2,
        order: 2,
        title_bn: 'নোটিফিকেশন লিস্ট',
        title_en: 'Notification List',
        url: `/admin/notification-list`,
        authority: ['view_notificationmaster'],
      },
      {
        has_cap: true,
        icon_name: 'cursor',
        id: 'notice',
        is_active: true,
        menu_item: 2,
        order: 2,
        title_bn: 'নোটিশ',
        title_en: 'Notice',
        url: `/admin/notice`,
        authority: ['view_headernotice'],
      },
    ],
    title_bn: 'সেন্ড নোটিফিকেশন',
    title_en: 'Send Notification',
    url: '',
  },
  {
    action: 'SUBMENU',
    color: '#bd5a1c',
    icon_name: 'cloud_plus',
    id: '10-admin',
    is_active: true,
    menu: 10,
    order: 10,
    authority: ['view_document'],
    sub_menu_items: [
      {
        has_cap: true,
        icon_name: 'pdf',
        id: 'file-1',
        is_active: true,
        menu_item: 1,
        order: 1,
        title_bn: 'ফাইল লিস্ট',
        title_en: 'File List',
        url: `/admin/file-list`,
        authority: ['view_document'],
      },
      {
        has_cap: true,
        icon_name: 'pdf',
        id: 'file-1',
        is_active: true,
        menu_item: 2,
        order: 2,
        title_bn: 'গুরুত্বপূর্ণ লিঙ্ক',
        title_en: 'Important Links',
        url: `/admin/important-links`,
        authority: ['view_document'],
      },
    ],
    title_bn: 'ইন্টারনাল ফাইলস',
    title_en: 'Internal Files',
    url: '',
  },
  {
    action: 'SUBMENU',
    color: '#bf3c3c',
    icon_name: 'lock',
    id: '11-admin',
    is_active: true,
    menu: 11,
    order: 11,
    authority: ['view_logentry'],
    sub_menu_items: [
      {
        has_cap: true,
        icon_name: 'key',
        id: 'audit',
        is_active: true,
        menu_item: 1,
        order: 1,
        title_bn: 'ক্রুড লগ',
        title_en: 'CRUD Log',
        url: `/admin/audit`,
        authority: ['view_logentry'],
      },
    ],
    title_bn: 'অডিট ট্রেইল',
    title_en: 'Audit Trail',
    url: '',
  },
  {
    action: 'SUBMENU',
    color: '#810202',
    icon_name: 'journalBookmark',
    id: '12-admin',
    is_active: true,
    menu: 12,
    order: 12,
    authority: ['view_documentack'],
    sub_menu_items: [
      {
        has_cap: true,
        icon_name: 'journal_text',
        id: 'report',
        is_active: true,
        menu_item: 1,
        order: 1,
        title_bn: 'রিপোর্ট',
        title_en: 'Report',
        url: `/admin/ack-report`,
        authority: ['view_documentack'],
      },
    ],
    title_bn: 'অকনোলেজড রিপোর্ট',
    title_en: 'Acknowledged Report',
    url: '',
  },
  {
    action: 'SUBMENU',
    color: '#F6B547',
    icon_name: 'feedback',
    id: '13-admin',
    is_active: true,
    menu: 13,
    order: 13,
    authority: ['view_all_feedback'],
    sub_menu_items: [
      {
        has_cap: true,
        icon_name: 'list_check',
        id: 'feedback',
        is_active: true,
        menu_item: 1,
        order: 1,
        title_bn: 'প্রতিক্রিয়া তালিকা',
        title_en: 'Feedback List',
        url: `/admin/feedback-list`,
        authority: ['view_all_feedback'],
      },
    ],

    title_bn: 'প্রতিক্রিয়া',
    title_en: 'Feedbacks',
    url: '',
  },
  {
    action: 'SUBMENU',
    color: '#F6B547',
    icon_name: 'bot',
    id: '13-admin',
    is_active: true,
    menu: 13,
    order: 13,
    authority: ['view_all_feedback'],
    sub_menu_items: [
      {
        has_cap: true,
        icon_name: 'list_check',
        id: 'feedback',
        is_active: true,
        menu_item: 1,
        order: 1,
        title_bn: 'ব্যবহারকারীর কার্যকলাপ তালিকা',
        title_en: 'User Acitivity List',
        url: `/admin/chatbot/message-list`,
        authority: ['view_all_feedback'],
      },
    ],

    title_bn: 'চর্কিবট',
    title_en: 'ChorkiBot',
    url: '',
  },
  {
    action: 'SUBMENU',
    color: '#F6B547',
    icon_name: 'fillTicketDetailedFill',
    id: '14-admin',
    is_active: true,
    menu: 13,
    order: 13,
    authority: ['view_ticket'],
    sub_menu_items: [
      {
        has_cap: true,
        icon_name: 'list_check',
        id: 'tickets',
        is_active: true,
        menu_item: 1,
        order: 1,
        title_bn: 'টিকিট',
        title_en: 'Tickets',
        url: `/admin/tickets`,
        authority: ['view_ticket'],
      },
      {
        has_cap: true,
        icon_name: 'list_check',
        id: 'hr-representative',
        is_active: true,
        menu_item: 1,
        order: 1,
        title_bn: 'মানব সম্পদ প্রতিনিধি',
        title_en: 'HR Representative',
        url: `/admin/hr-representative`,
        authority: ['view_manager', 'view_managergroup'],
      },
    ],

    title_bn: 'টিকিট ম্যানেজমেন্ট',
    title_en: 'Ticket Management',
    url: '',
  },
  {
    action: 'SUBMENU',
    color: '#F6B547',
    icon_name: 'settings',
    id: '15-admin',
    is_active: true,
    menu: 14,
    order: 14,
    authority: ['change_appsettings', 'delete_cache'],
    sub_menu_items: [
      {
        has_cap: true,
        icon_name: 'settings',
        id: 'settings',
        is_active: true,
        menu_item: 1,
        order: 1,
        title_bn: 'অ্যাপ্লিকেশন সেটিংস',
        title_en: 'Application Settings',
        url: `/admin/application-settings`,
        authority: ['change_appsettings'],
      },
      {
        has_cap: true,
        icon_name: 'settings',
        id: 'settings',
        is_active: true,
        menu_item: 1,
        order: 1,
        title_bn: 'অ্যাপ্লিকেশন সেটিংস',
        title_en: 'Popup Settings',
        url: `/admin/popup-settings`,
        authority: ['change_appsettings'],
      },
      {
        has_cap: true,
        icon_name: 'settings',
        id: 'settings',
        is_active: true,
        menu_item: 1,
        order: 1,
        title_bn: 'অ্যাপ্লিকেশন সেটিংস',
        title_en: 'Cache Clear',
        url: `/admin/cache-clear`,
        authority: ['delete_cache'],
      },
    ],

    title_bn: 'সেটিংস',
    title_en: 'Settings',
    url: '',
  },
];

export default adminMenuItems;
